// removed by extract-text-webpack-plugin
module.exports = {"HeaderBackground":"CollectionCover__HeaderBackground__38VU7","LogoContainer":"CollectionCover__LogoContainer__3heoy","Logo":"CollectionCover__Logo__164vn","CollectionLink":"CollectionCover__CollectionLink__3V83G","Title":"CollectionCover__Title__2IYhs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollectionCover/CollectionCover.css
// module id = 199
// module chunks = 0